import type { App } from 'vue'
import AppPageFilterBranch from './app-page-filter-branch.vue'
import AppPageFilterDate from './app-page-filter-date.vue'
import AppPageFilterSearch from './app-page-filter-search.vue'

export default {
  install (app: App) {
    app.component('AppPageFilterBranch', AppPageFilterBranch)
    app.component('AppPageFilterSearch', AppPageFilterSearch)
    app.component('AppPageFilterDate', AppPageFilterDate)
  },
}

declare module 'vue' {
  export interface GlobalComponents {
    AppPageFilterBranch: typeof AppPageFilterBranch,
    AppPageFilterSearch: typeof AppPageFilterSearch,
    AppPageFilterDate: typeof AppPageFilterDate,
  }
}
